<div [style.width]='arcSizePx'>
  <svg viewBox='0 0 36 36' [attr.class]="'circular-chart' + ' ' + ieHeightForSvg">
    <path
      class='circle-bg'
      [style.stroke]='circleFillColor'
      [style.stroke-width]='circleBgWidth'
      d='M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831'
    />

    <path
      class='circle'
      attr.stroke-dasharray='{{ percentage }}, 100'
      [style.stroke]='arcColor'
      [style.stroke-width]='arcWidth'
      d='M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831'
    />

    <text x='18' y='20.35' class='percentage' [style.fill]='textColor'>{{ percentage }}%</text>
  </svg>
</div>
